let impersonationAccessToken: string | undefined = undefined;

export const setImpersonationAccessToken = (token: string | undefined) => {
  impersonationAccessToken = token;
};

export const getImpersonationAccessToken = () => impersonationAccessToken;
